import { apiClient } from '../../../services/api/client';

export const staffAPI = {
  // Get department staff members
  getDepartmentStaff: (params = {}) => 
    apiClient.get('/api/v1/ac/staff-members/', { params }),
  
  // Create staff member
  createStaff: (data) => 
    apiClient.post('/api/v1/ac/staff-members/', data),
  
  // Get current staff member
  getCurrentStaff: () => 
    apiClient.get('/api/v1/ac/staff-members/me'),

  changeCurrentStaffPassword: (data) =>
    apiClient.post('/api/v1/ac/staff-members/me/password', data),

  // Set or change the current user's PIN (always requires current password)
  setCurrentStaffPin: (data) =>
    apiClient.post('/api/v1/ac/staff-members/me/pin', data),

  // Dismiss the "set up a PIN?" prompt without setting one
  dismissCurrentStaffPinPrompt: () =>
    apiClient.post('/api/v1/ac/staff-members/me/pin/dismiss'),

  // Remove the current user's PIN (requires current password)
  disableCurrentStaffPin: (data) =>
    apiClient.delete('/api/v1/ac/staff-members/me/pin', { data }),


  // Get staff member by ID
  getStaffById: (staffId) => 
    apiClient.get(`/api/v1/ac/staff-members/${staffId}`),
  
  // Update staff member
  updateStaff: (staffId, data) => 
    apiClient.put(`/api/v1/ac/staff-members/${staffId}`, data),
  
  // Delete staff member
  deleteStaff: (staffId) => 
    apiClient.delete(`/api/v1/ac/staff-members/${staffId}`),
  
  // Get staff member roles
  getStaffRoles: (staffId) =>
    apiClient.get(`/api/v1/ac/staff-members/${staffId}/roles`),

  // Files attached to a staff member (contracts and such); all need staff:update.
  // Whether the caller may see / add them follows the staff folder's access in Filer
  getStaffFilesAccess: () =>
    apiClient.get('/api/v1/ac/staff-members/files/access'),

  listStaffFiles: (staffId) =>
    apiClient.get(`/api/v1/ac/staff-members/${staffId}/files`),

  attachStaffFile: (staffId, fileId) =>
    apiClient.post(`/api/v1/ac/staff-members/${staffId}/files`, { file_id: fileId }),

  removeStaffFile: (staffId, staffMemberFileId) =>
    apiClient.delete(`/api/v1/ac/staff-members/${staffId}/files/${staffMemberFileId}`),

  // Get all department staff with roles embedded (bulk, avoids N+1)
  getDepartmentStaffWithRoles: (params = {}) =>
    apiClient.get('/api/v1/ac/staff-members/with-roles', { params }),
  
  // Assign role to staff
  assignRole: (staffId, data) => 
    apiClient.post(`/api/v1/ac/staff-members/${staffId}/roles`, data),
  
  // Remove role from staff
  removeRole: (staffId, roleId) =>
    apiClient.delete(`/api/v1/ac/staff-members/${staffId}/roles/${roleId}`),

  // Set current staff member's personal color
  setColor: (color) =>
    apiClient.put('/api/v1/ac/staff-members/me/color', { color }),
};